// src/pages/Login.js - SIMPLIFIED VERSION
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const { login, getRedirectPath } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setError(null);
      setLoading(true);
      
      // Login and get user data
      const result = await login(email, password);
      
      console.log('Login successful, navigating based on role:', result.userData.role);
      
      // Redirect based on role — delegates to AuthContext's getRedirectPath
      // instead of keeping a second, separate role list here. That
      // duplication is exactly what let 'mentor' and 'official' silently
      // fall through to "Invalid user role" while AuthContext already knew
      // where to send them.
      const redirectPath = getRedirectPath(result.userData.role);
      if (redirectPath === '/login') {
        setError('Invalid user role');
        setLoading(false);
      } else {
        window.location.href = redirectPath;
      }
      
    } catch (err) {
      // Handle specific error cases
      switch (err.code) {
        case 'auth/user-not-found':
        case 'auth/wrong-password':
        case 'auth/invalid-credential':
          setError('Invalid email or password');
          break;
        case 'auth/too-many-requests':
          setError('Too many failed login attempts. Please try again later');
          break;
        default:
          setError('An error occurred during login. Please try again');
          console.error('Login error:', err);
      }
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>Learning Platform</h1>
          <p>Please log in to continue</p>
        </div>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>
        
        <div className="login-footer">
          <a href="#forgot-password" onClick={(e) => {
            e.preventDefault();
            alert('Please contact your administrator to reset your password');
          }}>
            Forgot password?
          </a>
        </div>

        <div style={{
          marginTop: '1.25rem',
          textAlign: 'center',
          fontSize: '0.875rem',
          color: '#6b7280',
          borderTop: '1px solid #e5e7eb',
          paddingTop: '1.25rem',
        }}>
          New learner?{' '}
          <a
            href="/register"
            style={{
              color: 'var(--color-teal, #0d9488)',
              fontWeight: 500,
              textDecoration: 'none',
            }}
          >
            Create an account
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;